export type CompareOption = "time" | "targets";

interface GetAccountBalancesProps {
  merchantId: string;
  start: string;
  end: string;
  compareOption?: CompareOption;
}

export interface QuickBooksAccount {
  qbAccountId: string;
  accountName: string;
  accountType: string;
  balance: number;
}

export interface QuickBooksAccountBalance {
  _id: string;
  accounts: QuickBooksAccount[];
  totalBalance: number;
}

export interface QuickBooksCashflowData {
  _id: string;
  endingBalance: number;
  inflow: number;
  outflow: number;
  netChange: number;
  startingBalance: number;
}

export interface QuickBooksChartData {
  graphData: QuickBooksAccountBalance[];
}

export interface QuickBooksCashflowChartData {
  graphData: QuickBooksCashflowData[];
}

export interface QuickBooksAccountSummary {
  qbAccountId: string;
  accountName: string;
  accountType: string;
  balance: {
    value: number;
    compareValue: number;
  };
}

export interface QuickBooksAccountSummaryData {
  data: QuickBooksAccountSummary[];
}

type QuickBooksChartResponse = {
  data: QuickBooksChartData;
};

type GetFunction = <T>(url: string) => Promise<T>;

export class QuickBooksService {
  private get: GetFunction;

  constructor(getFn: GetFunction) {
    this.get = getFn;
  }

  async getAccountBalancesChart(params: GetAccountBalancesProps): Promise<QuickBooksCashflowChartData> {
    const { merchantId, start, end, compareOption = "time" } = params;
    const response = await this.get<QuickBooksCashflowChartData>(
      `quickbooks/cashflow/chart?merchantId=${merchantId}&start=${start}&end=${end}`
    );
    return response;
  }

  async getAccountBalancesSummary(params: GetAccountBalancesProps): Promise<QuickBooksAccountSummaryData> {
    const { merchantId, start, end, compareOption = "time" } = params;
    const response = await this.get<QuickBooksAccountSummaryData>(
      `quickbooks/account-balances/summary?merchantId=${merchantId}&start=${start}&end=${end}`
    );
    return response;
  }
} 